@if (data) {
  <div data-testid="dialog" class="dialog-overlay" (click)="onCancel()">
  <div
    class="dialog"
    [ngStyle]="{ width: data.width }"
    #dialogRef
    (click)="$event.stopPropagation()"
  >
    <h2 class="dialog-title">{{ data.title }}</h2>
    <div class="dialog-content">
      @if (!data.readOnly){
      <textarea
        [(ngModel)]="data.textArea"
        [placeholder]="data.placeholder"
        [readonly]="data.readOnly"
        data-testid="dialog-textArea"
      ></textarea>
    } @else {
      <p>{{ data.textArea || data.placeholder }}</p>}
    </div>
    <div class="dialog-actions">
      @if (data.cancelText) {
        <button class="btn-cancel" (click)="onCancel()">{{data.cancelText}}</button>
      }
      <button
        data-testid="dialog-confirm"
        class="btn-confirm"
        [disabled]="!data.enableConfirmButton"
        (click)="onConfirm(data.textArea!)">
        {{ data.confirmText }}
      </button>
    </div>
  </div>
</div>
}
